import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

// render - login
const Login = Loadable(lazy(() => import('pages/authentication/Login')));
const ForgotPassword = Loadable(lazy(() => import('pages/authentication/ForgotPassword')));
const RecoveryPassword = Loadable(lazy(() => import('pages/authentication/RecoveryPassword')));
const Register = Loadable(lazy(() => import('pages/authentication/Register')));

const AuthenticationRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: '/',
            element: <Login />
        },
        {
            path: 'login',
            element: <Login />
        },
        {
            path: 'forgot-password',
            element: <ForgotPassword />
        },
        {
            path: 'recovery-password/:token',
            element: <RecoveryPassword />
        },
        {
            path: 'register',
            element: <Register />
        }
    ]
};

export default AuthenticationRoutes;
